import axios from "axios";

export async function fetchBrregOrganization(orgnr) {
  const url = `https://data.brreg.no/enhetsregisteret/api/enheter/${encodeURIComponent(
    orgnr
  )}`;
  return await axios.get(url, {
    headers: { Accept: "application/json" },
  });
}

export async function searchBrregEntitiesByName(name, size = 10, page = 0) {
  const url = "https://data.brreg.no/enhetsregisteret/api/enheter";
  const params = { navn: name, size, page };
  return await axios.get(url, { params, headers: { Accept: "application/json" } });
}


